<template>
  <div class="information-list-desktop">
    <div v-if="buyOnlyPrePaidInfoText" class="information-list-desktop__information _pre-pay">
      {{ buyOnlyPrePaidInfoText }}
    </div>
    <template v-else>
      <div v-if="cntInfoText" class="information-list-desktop__information _left">
        {{ cntInfoText }}
      </div>

      <div v-if="isPromoDisabled" class="information-list-desktop__information">
        <promo-disabled @openAuth="handlerOpenAuthModal" />
      </div>
    </template>
    <div v-if="isPurchased" class="information-list-desktop__information">
      <bag16 :width="16" :height="16" class="information-list-desktop__icon _is-purchased" />
      Вы уже заказывали этот товар
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

import useAuthorizations from '@/compositions/user/useAuthorizations';

import PromoDisabled from '@/components/PromoDisabled/index.vue';
import Bag16 from '@/assets/sprite/svg/16/Bag_16.svg';

export default defineComponent({
  name: 'InformationList',
  components: { PromoDisabled, Bag16 },
  props: {
    isPromoDisabled: { type: Boolean, default: false },
    cntInfoText: { type: String, default: '' },
    buyOnlyPrePaidInfoText: { type: String, default: '' },
    isPurchased: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const { isAuthorized } = useAuthorizations();
    const handlerOpenAuthModal = () => {
      emit('openAuthModal');
    };

    return {
      isAuthorized,
      handlerOpenAuthModal,
    };
  },
});
</script>

<style lang="less">
.information-list-desktop {
  &__information {
    .small2();

    margin-top: @size-x3;
    display: flex;

    &:first-child {
      margin-top: 0;
    }

    &._pre-pay {
      color: @orange;
    }

    &._left {
      color: @red-error;
    }
  }

  &__icon {
    fill: @gray;
    margin-right: @size-x2;

    &._is-purchased {
      fill: @pink;
    }
  }
}
</style>
